module.exports = __webpack_public_path__ + "img/dummy.a65d4055.png";